import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    tenantMembersControllerAddTenantMemberV1: build.mutation<
      TenantMembersControllerAddTenantMemberV1ApiResponse,
      TenantMembersControllerAddTenantMemberV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.tenantId}/members`,
        method: 'POST',
        body: queryArg.addTenantMemberBody,
      }),
    }),
    tenantMembersControllerListTenantMembersV1: build.query<
      TenantMembersControllerListTenantMembersV1ApiResponse,
      TenantMembersControllerListTenantMembersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.tenantId}/members`,
      }),
    }),
    tenantMembersControllerGetTenantMemberV1: build.query<
      TenantMembersControllerGetTenantMemberV1ApiResponse,
      TenantMembersControllerGetTenantMemberV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.tenantId}/members/${queryArg.userId}`,
      }),
    }),
    tenantMembersControllerRemoveTenantMemberV1: build.mutation<
      TenantMembersControllerRemoveTenantMemberV1ApiResponse,
      TenantMembersControllerRemoveTenantMemberV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.tenantId}/members/${queryArg.userId}`,
        method: 'DELETE',
      }),
    }),
    tenantMembersControllerUpdateTenantMembershipV1: build.mutation<
      TenantMembersControllerUpdateTenantMembershipV1ApiResponse,
      TenantMembersControllerUpdateTenantMembershipV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.tenantId}/memberships/${queryArg.membershipId}`,
        method: 'PUT',
        body: queryArg.updateTenantMembershipBody,
      }),
    }),
    tenantMembersControllerRemoveTenantMembershipV1: build.mutation<
      TenantMembersControllerRemoveTenantMembershipV1ApiResponse,
      TenantMembersControllerRemoveTenantMembershipV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.tenantId}/memberships/${queryArg.membershipId}`,
        method: 'DELETE',
      }),
    }),
    tenantsAdminControllerCreateTenantV1: build.mutation<
      TenantsAdminControllerCreateTenantV1ApiResponse,
      TenantsAdminControllerCreateTenantV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants`,
        method: 'POST',
        body: queryArg.createTenantBody,
      }),
    }),
    tenantsAdminControllerListTenantsV1: build.query<
      TenantsAdminControllerListTenantsV1ApiResponse,
      TenantsAdminControllerListTenantsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/tenants` }),
    }),
    tenantsAdminControllerGetTenantV1: build.query<
      TenantsAdminControllerGetTenantV1ApiResponse,
      TenantsAdminControllerGetTenantV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.idOrSlug}`,
      }),
    }),
    tenantsAdminControllerUpdateTenantV1: build.mutation<
      TenantsAdminControllerUpdateTenantV1ApiResponse,
      TenantsAdminControllerUpdateTenantV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateTenantBody,
      }),
    }),
    tenantsAdminControllerRemoveTenantV1: build.mutation<
      TenantsAdminControllerRemoveTenantV1ApiResponse,
      TenantsAdminControllerRemoveTenantV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/tenants/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type TenantMembersControllerAddTenantMemberV1ApiResponse =
  /** status 200 Returns created tenant membership */ AddTenantMemberResponse;
export type TenantMembersControllerAddTenantMemberV1ApiArg = {
  tenantId: number;
  addTenantMemberBody: TenantMembershipCreate;
};
export type TenantMembersControllerListTenantMembersV1ApiResponse =
  /** status 200 Returns the list of tenant memberships */ ListTenantMembersResponse;
export type TenantMembersControllerListTenantMembersV1ApiArg = {
  tenantId: number;
};
export type TenantMembersControllerGetTenantMemberV1ApiResponse =
  /** status 200 Membership details for user in tenant */ GetTenantMemberResponse;
export type TenantMembersControllerGetTenantMemberV1ApiArg = {
  tenantId: number;
  userId: number;
};
export type TenantMembersControllerRemoveTenantMemberV1ApiResponse =
  /** status 200 Returns the count of deleted memberships */ RemoveTenantMemberResponse;
export type TenantMembersControllerRemoveTenantMemberV1ApiArg = {
  tenantId: number;
  userId: number;
};
export type TenantMembersControllerUpdateTenantMembershipV1ApiResponse =
  /** status 200 Returns updated tenant membership */ UpdateTenantMembershipResponse;
export type TenantMembersControllerUpdateTenantMembershipV1ApiArg = {
  tenantId: number;
  membershipId: number;
  updateTenantMembershipBody: TenantMembershipUpdate;
};
export type TenantMembersControllerRemoveTenantMembershipV1ApiResponse =
  /** status 200 Returns deleted tenant membership */ RemoveTenantMembershipResponse;
export type TenantMembersControllerRemoveTenantMembershipV1ApiArg = {
  tenantId: number;
  membershipId: number;
};
export type TenantsAdminControllerCreateTenantV1ApiResponse =
  /** status 200 Returns created tenant */ CreateTenantResponse;
export type TenantsAdminControllerCreateTenantV1ApiArg = {
  createTenantBody: CreateTenantBody;
};
export type TenantsAdminControllerListTenantsV1ApiResponse =
  /** status 200 Returns the list of tenants */ ListTenantsResponse;
export type TenantsAdminControllerListTenantsV1ApiArg = void;
export type TenantsAdminControllerGetTenantV1ApiResponse =
  /** status 200 Tenant details */ GetTenantResponse;
export type TenantsAdminControllerGetTenantV1ApiArg = {
  idOrSlug: string;
};
export type TenantsAdminControllerUpdateTenantV1ApiResponse =
  /** status 200 Returns updated tenant */ UpdateTenantResponse;
export type TenantsAdminControllerUpdateTenantV1ApiArg = {
  id: number;
  updateTenantBody: UpdateTenantBody;
};
export type TenantsAdminControllerRemoveTenantV1ApiResponse =
  /** status 200 Returns deleted tenant */ RemoveTenantResponse;
export type TenantsAdminControllerRemoveTenantV1ApiArg = {
  id: number;
};
export type AddTenantMemberResponse = {
  /** Tenant membership with populated relations */
  data: {
    /** Tenant membership ID */
    id: number;
    /** User ID */
    userId: number;
    /** Tenant ID */
    tenantId: number;
    /** Role ID */
    roleId: number;
    /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
    context: string;
    user?: {
      /** User ID */
      id: number;
      /** User email address */
      email: string;
      /** Full name */
      fullname: string;
      /** Company name */
      company: string;
    };
    tenant?: {
      /** Tenant ID */
      id: number;
      /** Tenant name */
      name: string;
      /** Tenant slug (unique identifier, must contain at least one letter) */
      slug: string;
    };
    role?: {
      /** Role ID */
      id: number;
      /** Role name */
      name: string;
      /** Optional description for the role */
      description: null | string;
    };
    /** Creation timestamp */
    createdAt: string;
    /** Last update timestamp */
    updatedAt: string;
  };
};
export type TenantMembershipCreate = {
  /** User ID to add to the tenant */
  userId: number;
  /** Tenant ID (optional - can be derived from route parameter) */
  tenantId?: number;
  /** Role ID to assign */
  roleId: number;
  /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
  context?: string;
};
export type ListTenantMembersResponse = {
  data: {
    /** Tenant membership ID */
    id: number;
    /** User ID */
    userId: number;
    /** Tenant ID */
    tenantId: number;
    /** Role ID */
    roleId: number;
    /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
    context: string;
    user?: {
      /** User ID */
      id: number;
      /** User email address */
      email: string;
      /** Full name */
      fullname: string;
      /** Company name */
      company: string;
    };
    tenant?: {
      /** Tenant ID */
      id: number;
      /** Tenant name */
      name: string;
      /** Tenant slug (unique identifier, must contain at least one letter) */
      slug: string;
    };
    role?: {
      /** Role ID */
      id: number;
      /** Role name */
      name: string;
      /** Optional description for the role */
      description: null | string;
    };
    /** Creation timestamp */
    createdAt: string;
    /** Last update timestamp */
    updatedAt: string;
  }[];
  meta: {
    total: number;
  };
};
export type GetTenantMemberResponse = {
  data: {
    /** Tenant membership ID */
    id: number;
    /** User ID */
    userId: number;
    /** Tenant ID */
    tenantId: number;
    /** Role ID */
    roleId: number;
    /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
    context: string;
    user?: {
      /** User ID */
      id: number;
      /** User email address */
      email: string;
      /** Full name */
      fullname: string;
      /** Company name */
      company: string;
    };
    tenant?: {
      /** Tenant ID */
      id: number;
      /** Tenant name */
      name: string;
      /** Tenant slug (unique identifier, must contain at least one letter) */
      slug: string;
    };
    role?: {
      /** Role ID */
      id: number;
      /** Role name */
      name: string;
      /** Optional description for the role */
      description: null | string;
    };
    /** Creation timestamp */
    createdAt: string;
    /** Last update timestamp */
    updatedAt: string;
  }[];
  meta: {
    total: number;
  };
};
export type RemoveTenantMemberResponse = {
  data: {
    count: number;
  };
};
export type UpdateTenantMembershipResponse = {
  /** Tenant membership with populated relations */
  data: {
    /** Tenant membership ID */
    id: number;
    /** User ID */
    userId: number;
    /** Tenant ID */
    tenantId: number;
    /** Role ID */
    roleId: number;
    /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
    context: string;
    user?: {
      /** User ID */
      id: number;
      /** User email address */
      email: string;
      /** Full name */
      fullname: string;
      /** Company name */
      company: string;
    };
    tenant?: {
      /** Tenant ID */
      id: number;
      /** Tenant name */
      name: string;
      /** Tenant slug (unique identifier, must contain at least one letter) */
      slug: string;
    };
    role?: {
      /** Role ID */
      id: number;
      /** Role name */
      name: string;
      /** Optional description for the role */
      description: null | string;
    };
    /** Creation timestamp */
    createdAt: string;
    /** Last update timestamp */
    updatedAt: string;
  };
};
export type TenantMembershipUpdate = {
  /** New role ID to assign */
  roleId?: number;
  /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
  context?: string;
};
export type RemoveTenantMembershipResponse = {
  /** Tenant membership with populated relations */
  data: {
    /** Tenant membership ID */
    id: number;
    /** User ID */
    userId: number;
    /** Tenant ID */
    tenantId: number;
    /** Role ID */
    roleId: number;
    /** Permission context/scope: "*" for tenant-wide, "resource_type" for all resources, "resource_type:id" for specific resource */
    context: string;
    user?: {
      /** User ID */
      id: number;
      /** User email address */
      email: string;
      /** Full name */
      fullname: string;
      /** Company name */
      company: string;
    };
    tenant?: {
      /** Tenant ID */
      id: number;
      /** Tenant name */
      name: string;
      /** Tenant slug (unique identifier, must contain at least one letter) */
      slug: string;
    };
    role?: {
      /** Role ID */
      id: number;
      /** Role name */
      name: string;
      /** Optional description for the role */
      description: null | string;
    };
    /** Creation timestamp */
    createdAt: string;
    /** Last update timestamp */
    updatedAt: string;
  };
};
export type CreateTenantResponse = {
  /** Tenant ID */
  id: number;
  /** Tenant name */
  name: string;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Optional description for the tenant */
  description: null | string;
  /** Whether this is the system tenant (computed from slug === "system") */
  isSystem: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
export type CreateTenantBody = {
  /** Tenant name */
  name: string;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Optional description for the tenant */
  description?: null | string;
};
export type ListTenantsResponse = {
  /** Tenant ID */
  id: number;
  /** Tenant name */
  name: string;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Optional description for the tenant */
  description: null | string;
  /** Whether this is the system tenant (computed from slug === "system") */
  isSystem: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
}[];
export type GetTenantResponse = {
  /** Tenant ID */
  id: number;
  /** Tenant name */
  name: string;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Optional description for the tenant */
  description: null | string;
  /** Whether this is the system tenant (computed from slug === "system") */
  isSystem: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
export type UpdateTenantResponse = {
  /** Tenant ID */
  id: number;
  /** Tenant name */
  name: string;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Optional description for the tenant */
  description: null | string;
  /** Whether this is the system tenant (computed from slug === "system") */
  isSystem: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
export type UpdateTenantBody = {
  /** Tenant name */
  name?: string;
  /** Optional description for the tenant */
  description?: null | string;
};
export type RemoveTenantResponse = {
  /** Tenant ID */
  id: number;
  /** Tenant name */
  name: string;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Optional description for the tenant */
  description: null | string;
  /** Whether this is the system tenant (computed from slug === "system") */
  isSystem: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
